import React from 'react'
import PropTypes from 'prop-types'
import * as R from 'ramda'
import './Markdown.module.scss'

const Markdown = ({ content, text2 }) => {
  const linkedContent1 = R.pipe(
    R.pathOr('', ['childMarkdownRemark', 'html']),
    R.replace('<a', '<a target="_blank"')
  )(content)
  const linkedContent2 = R.pipe(
    R.pathOr('', ['childMarkdownRemark', 'html']),
    R.replace('<a', '<a target="_blank"')
  )(text2)

  return (
    <div styleName='texts'>
      {linkedContent1 && <div styleName='markdown' dangerouslySetInnerHTML={{ __html: linkedContent1 }} />}
      {linkedContent2 && <div styleName='markdown' dangerouslySetInnerHTML={{ __html: linkedContent2 }} />}
    </div>
  )
}

Markdown.propTypes = {
  content: PropTypes.object.isRequired,
  text2: PropTypes.object
}

export default Markdown



// WEBPACK FOOTER //
// ./src/components/Markdown/Markdown.js